import React from "react"
import { Control } from "react-hook-form"
import BadgeShapeFields from "./BadgeShapeFields"
import { BadgeElementFormValues } from "../BadgeSidePanelForm"

type Props = {
  control: Control<BadgeElementFormValues>
}

const BadgeLineFields = ({ control }: Props) => (
  <BadgeShapeFields control={control} shapeType="line" />
)

export default BadgeLineFields
